module.exports = __webpack_public_path__ + "img/4.0e89e96b.png";